import _ from 'lodash';

import { matchPath } from 'react-router';

import { SIGNUP_HELP_TEXTS } from './constants';

export const getHelpTextKey = nextUrl =>
  _.first(
    _.filter(
      _.keys(SIGNUP_HELP_TEXTS),
      url => !_.isNil(matchPath(nextUrl, url))
    )
  );
